import React from 'react';
import { Box, Text } from 'grommet';
import useSWR from 'swr';
import { goneQuietSummary } from '../../utils/chart-data';
import { nonRedirectFetcher } from '../../utils/errors';
import { formatCurrencySI } from '../../utils/numbers';
import ChartCard from './ChartCard';
import ChartLink from './ChartLink';
import ChartRow from './ChartRow';
import { ChartRowsSkeleton } from './ChartSkeleton';
import GapTrack from './GapTrack';

const VIEW_CUSTOMERS = <ChartLink href="/customers" label={<Text size="small" color="text-weak">View customers</Text>} />;

// Regular customers who have stopped ordering. Only worth a card when there are some, so a new
// merchant's dashboard isn't padded with an empty one.
const GoneQuiet = ({ currency }) => {
    const { data, isLoading } = useSWR(
        '/api/reports/gone-quiet?limit=3',
        nonRedirectFetcher,
        { revalidateOnFocus: false, shouldRetryOnError: false },
    );

    if (isLoading) {
        return <ChartCard title="Gone quiet" action={VIEW_CUSTOMERS}><ChartRowsSkeleton track /></ChartCard>;
    }

    const customers = data?.data || [];
    if (customers.length === 0) return null;
    const longest = Math.max(...customers.map((customer) => customer.days_quiet));

    return (
        <ChartCard title="Gone quiet" action={VIEW_CUSTOMERS}>
            <Box gap="small">
                <Text weight={500}>{goneQuietSummary(data.customer_count, formatCurrencySI(data.yearly_spend_total, currency))}</Text>
                <Box gap="xsmall">
                    {customers.map((customer) => (
                        <ChartRow
                            key={customer.uuid}
                            name={customer.name}
                            value={`${customer.days_quiet} days quiet`}
                            detail={`usually ${customer.usual_gap_days}`}
                            href={`/customers/${customer.uuid}`}
                            event={{ section: 'gone_quiet', element: 'row' }}
                        >
                            <GapTrack value={customer.days_quiet} usual={customer.usual_gap_days} max={longest} />
                        </ChartRow>
                    ))}
                </Box>
            </Box>
        </ChartCard>
    );
};

export default GoneQuiet;
